<template>
    <div>
        <v-container fluid="">
            <v-layout class="pa-0">
            <v-flex xs6 class="pa-0">

            <v-data-table
            :items="organisations.types"
            >

            <template
                slot="headerCell"
                slot-scope="{ header }"
            >
                <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
                />
            </template>

            <template
                v-slot:item="obs"
            >
            <tr @click="getType(obs.item.reference)">
                <td>{{obs.item.description}}</td>  
            </tr>
            </template>
            </v-data-table>    
            </v-flex>

        <v-expand-transition>

                <v-flex xs5 offset-xs1 v-if="organisations  .type !== null">
                <v-text-field v-model="organisations.type.description" @input="changeType()" label="Naam">Naam</v-text-field>
                <v-layout justify-end="" style="min-height:78px;">
                <v-flex md6 xs6>
                <v-slide-x-transition>
                    <v-btn rounded="" block="" v-if="app.settings.change" @click="resetType()" color="warning">Reset</v-btn>
                </v-slide-x-transition>
                </v-flex>
                <v-flex md6 xs6>
                <v-slide-x-transition>
                    <v-btn rounded="" block="" v-if="app.settings.change" @click="updateType()" color="success">Opslaan</v-btn>
                </v-slide-x-transition>
                </v-flex>
            </v-layout>
                </v-flex>                                         
            </v-expand-transition>
            </v-layout>                    
        </v-container>

        <settings-organisation-fields></settings-organisation-fields>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["organisations", "app"])
  },

  methods: {
    getType(reference) {
      console.log(reference);
      this.$store.dispatch("organisations/getType", {
        reference: reference
      });
    },
    updateType() {
      this.$store.dispatch("organisations/updateType");
    },
    resetType() {
      this.$store.dispatch("organisations/resetType");
    }
  }
};
</script>
